export type SiteConfig = typeof siteConfig;

export const siteConfig = {
  name: "Franc-Succès",
  url: "https://franc-succes.fr",
  alternateNames: ["Franc-Succes", "Franc Succes"],
  // Dernier filet de sécurité : ne sert que pour les pages sans gabarit
  // SERP dédié. Doit rester vraie et distincte de la description de la
  // page d'accueil, sinon deux pages indexables partagent la même.
  description:
    "Mise en relation avec des professeurs particuliers, à domicile ou en ligne, de la 6e aux grandes écoles.",
  ogImage: "/logo.png",
  ogImageWidth: 512,
  ogImageHeight: 512,
  twitterHandle: "@FrancSucces",
  // Profils officiels, émis en `sameAs` dans le JSON-LD `Organization`.
  //
  // À ne renseigner qu'avec des profils réellement contrôlés par la marque :
  // un `sameAs` erroné rattache l'entité à un tiers. `links` ci-dessous vient
  // du gabarit HeroUI et pointe encore vers le site lui-même — ne pas le
  // réutiliser ici.
  socialProfiles: ["https://www.linkedin.com/company/franc-succes-tutorat"],
  navItems: [
    {
      label: "Accueil",
      href: "/",
    },
    {
      label: "Professeurs",
      href: "/tuteurs",
    },
    {
      label: "Blog",
      href: "/blog",
    },
    {
      label: "Devenir professeur",
      href: "/devenir-professeur",
    },
    {
      label: "Contact",
      href: "/contact",
    },
    {
      label: "ProfLinker",
      href: "/decouvrir-proflinker",
    },
  ],
  navMenuItems: [
    {
      label: "Mon profil",
      href: "/tableau-de-bord",
    },
    {
      label: "Tableau de bord",
      href: "/tableau-de-bord",
    },
    {
      label: "Blog",
      href: "/blog",
    },
    {
      label: "Mes annonces",
      href: "/tableau-de-bord",
    },
    {
      label: "Paramètres",
      href: "/tableau-de-bord",
    },
    {
      label: "Aide",
      href: "/contact",
    },
    {
      label: "Déconnexion",
      href: "/deconnexion",
    },
  ],
  links: {
    github: "https://franc-succes.fr",
    twitter: "https://franc-succes.fr",
    docs: "https://franc-succes.fr",
    discord: "https://franc-succes.fr",
    sponsor: "https://franc-succes.fr",
  },
};
